import { useEffect, useMemo, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router";
import {
  X,
  Mail,
  Phone,
  Building2,
  BadgeCheck,
  MapPin,
  UserCircle2,
  CalendarDays,
  IdCard,
  Clock,
  ShieldCheck,
  ArrowUpRight,
  Copy,
  ExternalLink,
  Power,
  ChevronRight,
  Briefcase,
  Monitor,
  Search,
  StickyNote,
  FileText,
  User,
  Globe,
  Quote,
  Building,
  Calendar,
  Key,
  Award,
  BookOpen,
  CheckCircle,
  Palette,
  Bell,
  Users,
  Ban,
  LockKeyhole,
  Lock,
  Image,
  Map,
  Globe2,
  Layers,
  MessageSquare,
  MailCheck,
  PhoneCall,
  Stars,
  DollarSign,
  CalendarCheck,
  CheckCircle2,
  Check,
  ThumbsDown,
  ThumbsUp,
  Trophy,
  XCircle,
  Pencil,
  Contact,
  Eye,
} from "lucide-react";
// import { useApiCall } from "../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import Tooltip from "../../../../../component/ui/tooltip";
import Swal from "sweetalert2";
// import WonDeal from "../../../../deals/deal/won-deal/won-form-deal";
import { Alert, Snackbar } from "@mui/material";
import CommentsSection from "../../../../../component/comment";
// import LostDeal from "../../../../deals/deal/lost-deal/lost-form-deal";
// import DealQuickView from "../../../../deals/deal/popup";
import EmployeeDirectoryAddUpdate from "../../../../organization/emplyee-directory/add-update";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import LostDeal from "../../../../mainDeals/deals/deal/lost-deal/lost-form-deal";
import WonDeal from "../../../../mainDeals/deals/deal/won-deal/won-form-deal";
import DealQuickView from "../../../../mainDeals/deals/deal/popup";

const tabs = [
  { key: "summary", label: "Summary" },
  { key: "customer_information", label: "About" },
  { key: "deals", label: "Deals" },
  { key: "call", label: "Calls" },
  { key: "emails", label: "Emails" },
  { key: "sms", label: "Sms" },
  { key: "comments", label: "Comments" },
];

function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}

// function useOnClickOutside(ref, handler) {
//   useEffect(() => {
//     function listener(event) {
//       if (!ref.current || ref.current.contains(event.target)) return;
//       handler(event);
//     }
//     document.addEventListener("mousedown", listener);
//     document.addEventListener("touchstart", listener);
//     return () => {
//       document.removeEventListener("mousedown", listener);
//       document.removeEventListener("touchstart", listener);
//     };
//   }, [ref, handler]);
// }

function Badge({ children, tone = "default", icon: Icon }) {
  const tones = {
    default: "bg-slate-100 text-slate-700",
    green: "bg-emerald-100 text-emerald-700",
    blue: "bg-blue-100 text-blue-700",
    amber: "bg-amber-100 text-amber-800",
    red: "bg-rose-100 text-rose-700",
    grey: "bg-neutral-100 text-neutral-700",
  };
  return (
    <span
      className={classNames(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium",
        tones[tone]
      )}
    >
      {Icon ? <Icon size={14} /> : null}
      {children}
    </span>
  );
}

function Stat({ title, value, icon: Icon, hint, tone = "default" }) {
  return (
    <div className="group relative rounded-2xl border border-solid border-slate-200 bg-white p-4 shadow-sm hover:shadow-md">
      <div className="flex items-start gap-3">
        {/* <div className="rounded-xl bg-slate-50 p-2">
            <Icon className="size-5" />
          </div> */}
        <div className="min-w-0">
          <div className="text-xs text-slate-500 capitalize">
            {title.includes("_")
              ? title.split("_").map((word) => ` ${word}`)
              : title}
          </div>
          {/* truncate */}
          <div className="text-lg font-semibold tracking-tight">{value}</div>
          {hint && <div className="mt-1 text-xs text-slate-400">{hint}</div>}
        </div>
      </div>
      {/* {tone !== "default" && (
          <div className="absolute right-3 top-3">
            <Badge tone={tone}>{tone === "green" ? "Good" : tone === "amber" ? "Watch" : "Check"}</Badge>
          </div>
        )} */}
    </div>
  );
}

function Field({ label, value, icon: Icon, copyable, link }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="grid grid-cols-12 items-center gap-2 rounded-xl border border-solid border-slate-200 bg-white p-3 transition hover:bg-slate-50">
      <div className="col-span-4 flex items-center gap-2 text-[13px] font-medium text-slate-500">
        {Icon ? <Icon className="size-4" /> : null}
        {label}
      </div>
      <div className="col-span-8 flex items-center justify-between gap-2 text-[13px] text-slate-800">
        {link ? (
          <a
            href={link}
            className="truncate underline decoration-slate-300 underline-offset-2 hover:text-blue-600 hover:decoration-blue-400"
          >
            {value}
          </a>
        ) : (
          <span className="truncate">{value}</span>
        )}
        {copyable && (
          <button
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(String(value ?? ""));
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
              } catch {}
            }}
            className="inline-flex items-center gap-1 rounded-md border border-solid border-slate-200 bg-white px-2 py-1 text-[11px] text-slate-600 hover:bg-slate-100"
          >
            <Copy className="size-3.5" /> {copied ? "Copied" : "Copy"}
          </button>
        )}
      </div>
    </div>
  );
}

export default function ContactQuickView({
  open = true,
  onClose = () => {},
  data,
  onAlert,
  ProductList = [],
  PackageList = [],
  DealStages = [],
  ClientList = [],
  UserList = [],
  onLoadMoreClients,
  hasMoreClients,
  isLoadingClients,

  onDealUpdated,
}) {
  const [contact, setcontact] = useState({});
  const [activeTab, setActiveTab] = useState("summary");
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState(contact?.contactstatus);
  const containerRef = useRef(null);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(false);
  const [showAddDealModal, setShowAddDealModal] = useState(false);
  const [clientDeals, setClientDeals] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [changeModal, setChangeModal] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const GetData = async (id) => {
    // setIsLoading(true);
    let apiData = JSON.stringify({
      userid: id,
    });

    try {
      let call = await apiCall({
        method: "get",
        url: `contacts/get-contact/${id}`,
        data: apiData,
      });
      let ContactData = call?.data;

      // console.log("ContactData", ContactData)

      let activity = ContactData?.recent_activity?.map((item) => {
        const dateObj = new Date(item.time);
        const formattedDate = dateObj
          .toISOString()
          .slice(0, 16)
          .replace("T", " ");
        // This gives "YYYY-MM-DD HH:MM"

        return {
          ts: formattedDate,
          text: item.data,
        };
      });

      const sdata = {
        // ---------- SUMMARY TAB ----------
        id: ContactData?.userid,
        name: ContactData?.name,
        email: ContactData?.email,
        phone: ContactData?.phone,
        source: ContactData?.product_name,
        page_source: ContactData?.page_source,
        created_at: ContactData?.created_at,
        stats: ContactData?.stats,

        // ---------- CUSTOMER INFORMATION TAB ----------
        altemail: ContactData?.altemail,
        alternatephone: ContactData?.alternatephone,
        usertype: ContactData?.usertype,
        country: ContactData?.country,
        tagline: ContactData?.tagline,
        userimg: ContactData?.userimg,
        companyname: ContactData?.companyname,
        address: ContactData?.address,
        city: ContactData?.city,
        state: ContactData?.state,
        zipcode: ContactData?.zipcode,
        verified: ContactData?.verified,
        verifykey: ContactData?.verifykey,
        badge: ContactData?.badge,
        view_tutorial: ContactData?.view_tutorial,
        active: ContactData?.active,
        theme: ContactData?.theme,
        AssignedTo: ContactData?.assigned_users,
        notify: ContactData?.notify,
        teamleadid: ContactData?.teamleadid,
        revoke_user: ContactData?.revoke_user,
        is_private: ContactData?.is_private,
        is_private_assignee: ContactData?.is_private_assignee,
        signupdate: formatDate(ContactData?.signupdate),
        signuptime: formatTs(ContactData?.signuptime * 1000),
        client_deals: ContactData?.client_deals ?? [],
      };

      setStatus(ContactData?.contactstatus);
      setcontact(sdata);
      setClientDeals(sdata.client_deals || []);
      setIsLoading(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  // useOnClickOutside(containerRef, () => onClose());

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key.toLowerCase() === "f" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        const el = document.getElementById("quickview-search");
        el?.focus();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // console.log("contact in fields", contact);

  const onSuccess = (message, type) => {
    if (type == "won") {
      onClose();
      if (onAlert) {
        onAlert("success", message);
      }
    } else {
      setAlertData({ isShow: true, type: "success", message: message });
      GetData(contact?.id);
      setChangeModal(false);
    }
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const fields = useMemo(
    () => [
      // ---------- SUMMARY TAB ----------
      { tab: "summary", label: "ID", value: contact?.id ?? "-", icon: IdCard },
      {
        tab: "summary",
        label: "Name",
        value: contact?.name ?? "-",
        icon: User,
      },
      {
        tab: "summary",
        label: "Email",
        value: contact?.email ?? "-",
        icon: Mail,
        copyable: true,
        link: `mailto:${contact?.email}`,
      },
      {
        tab: "summary",
        label: "Phone",
        value: contact?.phone ?? "-",
        icon: Phone,
        copyable: true,
        link: `tel:${contact?.phone}`,
      },
      {
        tab: "summary",
        label: "Product",
        value: contact?.source ?? "-",
        icon: ExternalLink,
      },
      {
        tab: "summary",
        label: "Brand",
        value: contact?.page_source ?? "-",
        icon: Globe,
      },
      {
        tab: "summary",
        label: "Date",
        value: contact?.signupdate ?? "-",
        icon: Calendar,
      },
      // { tab: "summary", label: "Notify", value: contact?.notify, icon: Bell },
      // { tab: "summary", label: "Team Lead ID", value: contact?.teamleadid, icon: Users },
      {
        tab: "summary",
        label: "Assigned",
        value: (
          <div className="flex -space-x-2">
            {Array.isArray(contact?.AssignedTo) &&
            contact.AssignedTo.length > 0 ? (
              contact.AssignedTo.map((user, idx) => (
                <Tooltip key={idx} content={user.name} position="top center">
                  <div
                    className={`relative ${idx !== 0 ? "-ml-0" : ""}`}
                    // style={{
                    //   zIndex: lead.AssignedTo.length - idx,
                    // }}
                  >
                    {user?.userimg ? (
                      <img
                        src={user.userimg}
                        alt={user.name}
                        className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                        onError={(e) => {
                          e.target.onerror = null; // prevent infinite loop
                          e.target.style.display = "none";
                          const fallback = document.createElement("div");
                          fallback.className =
                            "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 text-black text-xs font-medium border-2 border-white shadow-sm";
                          fallback.innerText = (
                            (user?.name?.split(" ")[0]?.[0] || "") +
                            (user?.name?.split(" ")[1]?.[0] || "")
                          ).toUpperCase();
                          e.target.parentElement.appendChild(fallback);
                        }}
                      />
                    ) : (
                      <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 text-black text-xs font-medium border-2 border-white shadow-sm">
                        {(user?.name?.split(" ")[0]?.[0] || "") +
                          (user?.name?.split(" ")[1]?.[0] || "")}
                      </div>
                    )}
                  </div>
                </Tooltip>
              ))
            ) : (
              <span className="text-gray-400 text-sm">-</span>
            )}
          </div>
        ),
        icon: UserCircle2,
      },

      // ---------- CUSTOMER INFORMATION TAB ----------
      {
        tab: "customer_information",
        label: "Alternate Email",
        value: contact?.altemail ?? "-",
        icon: Mail,
        copyable: true,
        link: contact?.altemail ? `mailto:${contact?.altemail}` : null,
      },
      {
        tab: "customer_information",
        label: "Alternate Phone",
        value: contact?.alternatephone ?? "-",
        icon: Phone,
        copyable: true,
        link: contact?.alternatephone ? `tel:${contact?.alternatephone}` : null,
      },
      // { tab: "customer_information", label: "User Type", value: contact?.usertype, icon: FileText },
      {
        tab: "customer_information",
        label: "Country",
        value: contact?.country ?? "-",
        icon: Globe2,
      },
      {
        tab: "customer_information",
        label: "City",
        value: contact?.city ?? "-",
        icon: Building,
      },
      {
        tab: "customer_information",
        label: "State",
        value: contact?.state ?? "-",
        icon: Building2,
      },
      {
        tab: "customer_information",
        label: "Tagline",
        value: contact?.tagline ?? "-",
        icon: Quote,
      },
      {
        tab: "customer_information",
        label: "Company",
        value: contact?.companyname ?? "-",
        icon: Briefcase,
      },
      // { tab: "customer_information", label: "Address", value: contact?.address, icon: MapPin },
      {
        tab: "customer_information",
        label: "Zip Code",
        value: contact?.zipcode ?? "-",
        icon: Map,
      },
      // { tab: "customer_information", label: "Signup Time", value: contact?.signuptime, icon: Clock },
      {
        tab: "customer_information",
        label: "Badge",
        value: contact?.badge ?? "-",
        icon: Award,
      },
    ],
    [contact, status]
  );

  const filteredFields = fields.filter(
    (f) =>
      (!query ||
        `${f.label} ${f.value}`.toLowerCase().includes(query.toLowerCase())) &&
      (activeTab === "summary"
        ? ["summary", "work", "personal"].includes(f.tab)
        : f.tab === activeTab)
  );

  useEffect(() => {
    GetData(data?.userid);
  }, [data]);

  // console.log(data);

  // const statConfig = {
  //   total_deals_count: {
  //     label: "Total Deals",
  //     icon: Briefcase,
  //     format: (val) => val ?? 0,
  //     tone: "green",
  //   },
  //   total_deals_amount: {
  //     label: "Total Deal Amount",
  //     icon: DollarSign,
  //     format: (val) => `$${val ?? 0}`,
  //     tone: "amber",
  //   },
  //   prev_payment_date: {
  //     label: "Previous Payment",
  //     icon: CalendarDays,
  //     format: (val) => (val ? new Date(val).toLocaleDateString() : "N/A"),
  //     tone: "red",
  //   },
  //   next_payment_date: {
  //     label: "Next Payment",
  //     icon: CalendarCheck,
  //     format: (val) => (val ? new Date(val).toLocaleDateString() : "N/A"),
  //     tone: "green",
  //   },
  // };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.aside
            ref={containerRef}
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 40, opacity: 0 }}
            transition={{ type: "spring", stiffness: 380, damping: 32 }}
            className="relative mt-auto mr-[2vh] mb-auto ml-0 flex h-[96vh] w-[750px] max-w-[98vw] flex-col overflow-hidden rounded-3xl border border-solid border-slate-200 bg-gradient-to-b from-white to-slate-50 shadow-xl"
            aria-modal
            role="dialog"
          >
            {isLoading ? (
              <>
                {/* Header */}
                <div className="border-b border-solid border-slate-200 bg-white/90 p-4 backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                  <div className="flex flex-wrap items-center justify-between gap-3 w-full">
                    <div className="flex min-w-0 items-center gap-3">
                      {/* <img
                            src={contact?.userimg}
                            alt={contact?.name}
                            className="size-12 rounded-2xl object-cover ring-2 ring-white shadow"
                          /> */}
                      <div className="flex items-center justify-center size-12 bg-slate-200 rounded-full overflow-hidden">
                        <p className="capitalize font-semi-bold text-base text-black">
                          {contact?.name
                            ?.split(" ")
                            ?.map((n, i) => n.charAt(0))}
                        </p>
                      </div>
                      <div className="min-w-0">
                        <div className="flex items-center gap-2">
                          <h2 className="truncate text-lg font-semibold tracking-tight text-slate-900">
                            {contact?.name}
                          </h2>
                          {/* <Badge tone="green" icon={BadgeCheck}>{status}</Badge>
                              <Badge tone="blue" icon={Briefcase}>{contact?.role}</Badge> */}
                        </div>
                        <div className="mt-1 flex flex-wrap items-center gap-2 text-sm text-slate-500">
                          <span className="inline-flex items-center gap-1">
                            <MailCheck className="size-4" /> {contact?.email}
                          </span>

                          <span className="inline-flex items-center gap-1">
                            <PhoneCall className="size-4" /> {contact?.phone}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-2">
                      {/* <Link to={`/contacts/contact/${data.userid}`}
                            className="inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                          // onClick={() => window.alert("Opening full profile… (wire to route)")}
                          >
                            <ExternalLink className="size-4" /> View Full Profile
                          </Link> */}
                      <button
                        className="inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                        onClick={() => setShowAddDealModal(true)}
                      >
                        <Briefcase className="size-4" /> Add Deal
                      </button>

                      <button
                        className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                        onClick={onClose}
                        aria-label="Close"
                      >
                        <X className="size-4" /> Exit
                      </button>
                    </div>
                  </div>

                  {/* Quick actions */}
                  <div className="mt-4 flex flex-wrap items-center gap-2">
                    <QuickAction
                      icon={Mail}
                      label="Email"
                      href={`mailto:${contact?.email}`}
                    />
                    <QuickAction
                      icon={Phone}
                      label="Call"
                      href={`tel:${contact?.phone}`}
                    />
                    {/* <QuickAction icon={MessageSquare} label="Message" onClick={() => window.alert("Open internal chat")} /> */}
                    {/* <QuickAction icon={PencilLine} label="Edit" onClick={() => window.alert("Open edit form")} /> */}
                    {/* <QuickAction
                          icon={Power}
                          label={status === "Active" ? "Deactivate" : "Activate"}
                        // onClick={() => setStatus(s => (s === "Active" ? "Inactive" : "Active"))}
                        /> */}
                    <div className="ml-auto flex items-center gap-2">
                      <kbd className="rounded-md border border-solid bg-white px-1.5 py-1 text-[10px] text-slate-500">
                        ⌘/Ctrl
                      </kbd>
                      <span className="text-[10px] text-slate-500">
                        + F to search
                      </span>
                    </div>
                  </div>
                </div>

                {/* Body */}
                <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-hidden p-4 w-full">
                  {/* Left: main content */}
                  <div className="col-span-12 flex min-h-0 flex-col gap-4">
                    {/* Top stats */}
                    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
                      {contact?.stats?.map((ele, idx) => {
                        return (
                          <Stat
                            title={ele?.key}
                            value={ele?.value}
                            icon={CalendarDays}
                          />
                        );
                      })}
                    </div>

                    {/* Tabs */}
                    <div className="flex items-center justify-between gap-2">
                      <div className="flex flex-wrap items-center gap-1">
                        {tabs?.map((t) => (
                          <button
                            key={t.key}
                            onClick={() => setActiveTab(t.key)}
                            className={classNames(
                              "rounded-md px-[12px] py-[8px] text-sm font-medium border border-solid border-[#E1E4EA]",
                              activeTab === t.key
                                ? "bg-[#F5F5F5] text-[#0E121B]"
                                : "text-slate-600 hover:bg-slate-100"
                            )}
                          >
                            {t.label}
                          </button>
                        ))}
                      </div>
                      <div className="relative">
                        <Search className="pointer-events-none absolute left-3 top-2.5 size-4 text-slate-400" />
                        <input
                          id="quickview-search"
                          placeholder="Search fields…"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          className="w-64 rounded-2xl border border-solid border-slate-200 bg-white py-2 pl-9 pr-3 text-sm outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-slate-900/10"
                        />
                      </div>
                    </div>

                    <div className="h-full overflow-auto rounded-2xl py-2">
                      {/* Render fields for current tab (or summary) */}
                      <div className="grid grid-cols-1 gap-3">
                        {filteredFields?.map((f, idx) => (
                          <Field key={idx} {...f} />
                        ))}
                      </div>
                      {activeTab === "notes" && <Notes />}
                      {activeTab === "assets" && (
                        <Assets assets={contact?.assets} />
                      )}
                      {activeTab === "activity" && (
                        <Activity items={contact?.activity} />
                      )}

                      {activeTab === "attendance" && (
                        <div className="space-y-3">
                          <Field
                            label="Status"
                            value={`${contact?.attendanceToday?.status} (${contact?.attendanceToday?.shiftAdherence})`}
                            icon={Clock}
                          />
                          <div className="rounded-2xl border border-solid border-slate-200 bg-white p-4">
                            <h4 className="mb-2 text-sm font-semibold">
                              Today at a glance
                            </h4>
                            <div className="grid grid-cols-3 gap-3 text-sm">
                              <MiniStat
                                label="Planned Shift"
                                value={contact?.shift}
                              />
                              <MiniStat
                                label="Hours Logged"
                                value={`${contact?.attendanceToday.hours}h`}
                              />
                              <MiniStat
                                label="Last Login"
                                value={contact?.lastLogin}
                              />
                            </div>
                          </div>
                          <div className="rounded-2xl border border-solid border-slate-200 bg-white p-4">
                            <h4 className="mb-2 text-sm font-semibold">
                              Leave Balance
                            </h4>
                            <div className="grid grid-cols-3 gap-3 text-sm">
                              {Object.entries(contact?.leaveBalance)?.map(
                                ([k, v]) => (
                                  <MiniStat
                                    key={k}
                                    label={capitalize(k)}
                                    value={`${v} days`}
                                  />
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {activeTab === "deals" && (
                        <div className="space-y-3">
                          {contact?.client_deals?.length > 0 ? (
                            clientDeals.map((deal, i) => (
                              <DealCard
                                key={i}
                                userid={contact?.id}
                                deal={deal}
                                ProductList={ProductList}
                                PackageList={PackageList}
                                DealStages={DealStages}
                                ClientList={ClientList}
                                UserList={UserList}
                                onSubmit={onSuccess}
                                onError={onError}
                                onStatusChange={(dealId, newStatus) => {
                                  // UPDATE STATE IMMEDIATELY
                                  setClientDeals((prevDeals) =>
                                    prevDeals.map((d) =>
                                      d.dealid === dealId
                                        ? {
                                            ...d,
                                            current_stage: {
                                              ...d.current_stage,
                                              dealstatus: newStatus,
                                            },
                                          } // new object
                                        : d
                                    )
                                  );
                                }}
                              />
                            ))
                          ) : (
                            <div className="text-sm text-slate-500">
                              No deals found for this contact.
                            </div>
                          )}
                        </div>
                      )}

                      {activeTab === "comments" && (
                        <CommentsSection
                          type="contact"
                          id={contact?.id}
                          apiBaseUrl="contact"
                          setAlertData={setAlertData}
                        />
                      )}

                      {activeTab === "call" && (
                        <TabPlaceholder
                          icon={PhoneCall}
                          title="Calls"
                          message="We are working on the call logs and recordings section."
                        />
                      )}

                      {activeTab === "emails" && (
                        <TabPlaceholder
                          icon={Mail}
                          title="Emails"
                          message="Email activity and history will be available soon."
                        />
                      )}

                      {activeTab === "sms" && (
                        <TabPlaceholder
                          icon={MessageSquare}
                          title="SMS"
                          message="SMS communication history is under development."
                        />
                      )}
                    </div>
                  </div>

                  {/* Right: context column */}
                  {/* <div className="col-span-12 flex min-h-0 flex-col gap-4 lg:col-span-4">
                        <div className="rounded-2xl border border-solid border-slate-200 bg-white p-4">
                          <h3 className="mb-3 flex items-center justify-between text-sm font-semibold">
                            Highlights
                            <Badge tone="blue">Real-time</Badge>
                          </h3>
                          <ul className="space-y-2 text-sm text-slate-700">
                            <li className="flex items-start gap-2"><ArrowUpRight className="mt-0.5 size-4" /> Completed 9/9 hours today</li>
                            <li className="flex items-start gap-2"><ShieldCheck className="mt-0.5 size-4" /> No policy flags in last 90 days</li>
                            <li className="flex items-start gap-2"><Monitor className="mt-0.5 size-4" /> All assets compliant</li>
                          </ul>
                        </div>

                        <div className="rounded-2xl border border-solid border-slate-200 bg-white p-4">
                          <h3 className="mb-3 text-sm font-semibold">Tags</h3>
                          <div className="flex flex-wrap gap-2">
                            {contact?.tags?.map(t => (
                              <span key={t} className="rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-700">{t}</span>
                            ))}
                            <button className="rounded-full border border-dashed border-slate-300 px-3 py-1 text-xs text-slate-500 hover:bg-slate-50">+ Add</button>
                          </div>
                        </div>

                        <div className="min-h-0 flex-1 overflow-auto rounded-2xl border border-solid border-slate-200 bg-white p-4">
                          <h3 className="mb-3 text-sm font-semibold">Recent Activity</h3>
                          <Activity items={contact?.activity} compact />
                        </div>
                      </div> */}
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between gap-2 border-t border-solid border-slate-200 bg-white p-3 w-full">
                  <div className="flex items-center gap-2 text-xs text-slate-500">
                    <IdCard className="size-4" /> ID {contact?.id}
                    {/* <span>•</span>
                        <CalendarDays className="size-4" /> Joined {formatDate(contact?.doj)} */}
                  </div>
                  <div className="flex items-center gap-2">
                    {/* <button
                          className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm hover:bg-slate-50"
                          onClick={() => {
                            setActiveTab('notes');
                            setTimeout(() => {
                              const el = document.getElementById("addNotesField");
                              el?.focus();
                            }, 250);
                          }}>
                          <StickyNote className="mr-1 inline size-4" />
                          Add Note
                        </button> */}
                    {/* <button className="rounded-xl bg-slate-900 px-3 py-2 text-sm text-white hover:bg-slate-800">Save Changes</button> */}
                  </div>
                </div>
              </>
            ) : (
              <InnerLoader wrapperClass={"w-full"} />
            )}
          </motion.aside>

          {showAddDealModal && (
            // <EditDealModal
            //   open={showAddDealModal}
            //   onClose={() => setShowAddDealModal(false)}
            //   ProductList={ProductList}
            //   PackageList={PackageList}
            //   DealStages={DealStages}
            //   ClientList={ClientList}
            //   UserList={UserList}
            //   onLoadMoreClients={onLoadMoreClients}
            //   hasMoreClients={hasMoreClients}
            //   isLoadingClients={isLoadingClients}
            //   contactId={contact?.id}
            //   dealData={{ contactid: contact?.id }} // new deal
            //   onDealUpdated={() => GetData(contact?.id)} // ✅ refresh list after adding new deal
            //   onSubmit={onSuccess}
            //   onError={onError}

            // />

            <EmployeeDirectoryAddUpdate
              open={showAddDealModal}
              onClose={() => {
                setShowAddDealModal(false);
              }}
              data={{ contactid: contact?.id }}
              tabIndex={1}
              contactId={contact?.id}
              onDealUpdated={() => GetData(contact?.id)} // refresh after update
              onSubmit={onSuccess}
              onError={onError}
            />
          )}

          <Snackbar
            open={alertData?.isShow}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={alertData?.type}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {alertData?.message}
            </Alert>
          </Snackbar>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function QuickAction({ icon: Icon, label, href, onClick }) {
  const className =
    "inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50";
  if (href)
    return (
      <a className={className} href={href}>
        <Icon className="size-4" /> {label}
      </a>
    );
  return (
    <button className={className} onClick={onClick}>
      <Icon className="size-4" /> {label}
    </button>
  );
}

function Activity({ items, compact = false }) {
  return (
    <ul className="space-y-3">
      {items?.map((a, i) => (
        <li key={i} className="flex items-start gap-3">
          <div className="mt-1 h-5 w-5 rounded-full bg-slate-100 ring-1 ring-slate-200" />
          <div className="min-w-0 flex-1">
            <div className="text-[13px] text-slate-800 pb-[5px]">{a.text}</div>
            <div className="text-[11px] text-slate-400">{formatTs(a.ts)}</div>
          </div>
        </li>
      ))}
      {!compact && (
        <button className="mt-1 inline-flex items-center gap-1 text-xs text-slate-600 hover:underline">
          View full activity <ChevronRight className="size-4" />
        </button>
      )}
    </ul>
  );
}

function Assets({ assets }) {
  return (
    <div className="space-y-3">
      {assets?.map((a, i) => (
        <div
          key={i}
          className="flex items-center justify-between rounded-xl border border-solid border-slate-200 bg-white p-3"
        >
          <div className="flex min-w-0 items-center gap-3">
            <Monitor className="size-5" />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium">{a.name}</div>
              <div className="truncate text-xs text-slate-500">{a.id}</div>
            </div>
          </div>
          {/* <Badge tone={a.status === "Assigned" ? "blue" : "grey"}>{a.status}</Badge> */}
        </div>
      ))}
      <button className="inline-flex items-center gap-1 text-xs text-slate-600 hover:underline">
        Manage assets <ChevronRight className="size-4" />
      </button>
    </div>
  );
}

function Notes() {
  const [notes, setNotes] = useState([
    {
      id: 1,
      text: "Great initiative on latest branding sprint. Keep momentum for Q4.",
      ts: Date.now() - 86400000,
    },
  ]);
  const [text, setText] = useState("");
  return (
    <div className="space-y-3">
      <div className="rounded-2xl border border-solid border-slate-200 bg-white p-3">
        <textarea
          id="addNotesField"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add a manager note (visible to HR/Managers)…"
          className="min-h-[90px] w-full resize-y rounded-xl border border-solid border-slate-200 bg-slate-50 p-3 text-sm outline-none focus:ring-2 focus:ring-slate-900/10"
        />
        <div className="mt-2 flex justify-end">
          <button
            onClick={() => {
              if (!text.trim()) return;
              setNotes((n) => [{ id: Date.now(), text, ts: Date.now() }, ...n]);
              setText("");
            }}
            className="rounded-xl bg-slate-900 px-3 py-1.5 text-xs text-white hover:bg-slate-800"
          >
            Save Note
          </button>
        </div>
      </div>
      <ul className="space-y-2">
        {notes?.map((n) => (
          <li
            key={n.id}
            className="rounded-xl border border-solid border-slate-200 bg-white p-3"
          >
            <div className="text-sm text-slate-800">{n.text}</div>
            <div className="text-[11px] text-slate-400">
              {new Date(n.ts).toLocaleString()}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

function MiniStat({ label, value }) {
  return (
    <div className="rounded-xl border border-solid border-slate-200 bg-slate-50 p-3 text-center">
      <div className="text-[11px] text-slate-500">{label}</div>
      <div className="text-sm font-semibold text-slate-800">{value}</div>
    </div>
  );
}

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

function formatTs(ts) {
  try {
    const d =
      typeof ts === "string" ? new Date(ts.replace(" ", "T")) : new Date(ts);
    return d.toLocaleString();
  } catch {
    return String(ts);
  }
}

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function DealCard({
  deal,
  userid,
  onStatusChange,
  onCommentAdd,
  ProductList = [],
  PackageList = [],
  DealStages = [],
  ClientList = [],
  UserList = [],
  onSubmit = () => {},
  onError = () => {},
}) {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);
  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);
  const [localStage, setLocalStage] = useState(
    deal?.current_stage?.dealstatus ?? "-"
  );

  const apiCall = useApiCall();

  const handleSuccess = (message, type) => {
    setShowWonModal(false);
    setShowLostModal(false);
    setShowEditModal(false);
    onSubmit(message, type); // ✅ call parent prop
  };

  const handleError = (message) => {
    if (onError) onError(message); // ✅ call parent prop
  };

  // const stage = deal?.current_stage?.dealstatus ?? "-";

  const metas = Object.fromEntries(
    deal?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? []
  );

  const isWon = deal?.current_stage?.dealstatus === "Won";
  const isLost = deal?.current_stage?.dealstatus === "Lost";
  const currentStageIndex = DealStages.findIndex(
    (s) => s.name === deal?.current_stage?.dealstatus
  );
  const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";
  const isWonOrLost = isWon || isLost;

  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});

  const formatStageKey = (stage) => {
    return stage.toLowerCase().replace(/\s+/g, "_"); // "In Progress" -> "in_progress"
  };

  // --- HANDLE STAGE CHANGE ---
  const handleStageChange = async (newStage) => {
    const lowerStage = formatStageKey(newStage); // lowercase + underscores
    const currentStage = deal?.current_stage?.dealstatus ?? "-"; // ✅ added

    if (lowerStage === "won") {
      setWonFormDeal(deal);
      setShowWonModal(true);
      return;
    }

    if (lowerStage === "lost") {
      setLostFormDeal({ dealkey: deal.dealkey, name: deal.name });
      setShowLostModal(true);
      return;
    }

    const resultSwal = await Swal.fire({
      title: `Move deal "${deal.name}"?`,
      text: `Move from "${currentStage}" to "${newStage}"?`, // ✅ fixed reference
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (resultSwal.isConfirmed) {
      try {
        await apiCall({
          method: "post",
          url: "deals/update-deal-status",
          data: { dealkey: deal.dealkey, dealstatus: lowerStage },
        });

        // **Update card immediately without reload**
        onStatusChange(deal.dealid, newStage); // ✅ keep `newStage` or `lowerStage` depending on your display logic

        Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
      } catch (err) {
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "error"
        );
      }
    }
  };

  return (
    <>
      <div
        className="relative rounded-xl border border-slate-200 bg-white px-5 py-4 
             shadow-sm hover:shadow-md transition-all duration-300 
             space-y-3 text-sm w-full cursor-pointer hover:-translate-y-[1px]"
      >
        {/* Header */}
        <div className="flex justify-between items-start">
          <div className="flex flex-col">
            <h3 className="font-semibold text-slate-800 flex items-center gap-2 text-[15px]">
              <Briefcase className="size-4 text-blue-600" />
              {deal?.name ?? "Untitled Deal"}{" "}
              <span className="text-xs text-slate-500">#{deal?.dealid}</span>
            </h3>
          </div>

          <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-blue-700">
            {metas?.dealamount ? `$${metas?.dealamount}` : "—"}
          </span>
        </div>

        {/* Stage Pipeline */}
        <div className="mt-2">
          <p className="text-xs text-slate-500 mb-1 font-medium">
            Stage Pipeline
          </p>
          <div className="flex w-full h-7 overflow-hidden rounded-md">
            {DealStages.map((s, i) => {
              const isActive = !isWonOrLost && i <= currentStageIndex;
              const isFirst = i === 0;
              const isLast = i === DealStages.length - 1;

              let clipPath = "";
              if (isFirst) {
                clipPath =
                  "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)";
              } else if (isLast) {
                clipPath = "polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0)";
              } else {
                clipPath =
                  "polygon(0 0, 10px 50%, 0 100%, calc(100% - 10px) 100%, 100% 50%, calc(100% - 10px) 0)";
              }

              return (
                <div
                  key={s.id}
                  onClick={() => !isWonOrLost && handleStageChange(s.name)} // s.name will automatically go lowercase in handleStageChange
                  title={s.name}
                  style={{
                    clipPath,
                    WebkitClipPath: clipPath,
                    backgroundColor:
                      i <= currentStageIndex && !isWonOrLost
                        ? activeColor
                        : "#e5e7eb",
                    transition: "background-color 0.3s ease",
                    cursor: isWonOrLost ? "not-allowed" : "pointer",
                  }}
                  className="flex-1 relative flex items-center justify-center text-[10px] font-medium text-white select-none"
                >
                  {i <= currentStageIndex && !isWonOrLost ? (
                    <Check className="size-3" />
                  ) : (
                    s.name[0]
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Actions Row */}
        <div className="flex justify-between items-center mt-4">
          {/* Won/Lost Badge */}
          <div>
            {(isWon || isLost) && (
              <div
                className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${
                  isWon
                    ? "bg-green-100 text-green-700"
                    : "bg-rose-100 text-rose-700"
                }`}
              >
                {isWon ? (
                  <Trophy className="size-3" />
                ) : (
                  <XCircle className="size-3" />
                )}
                {isWon ? "Won" : "Lost"}
              </div>
            )}
            {!isWon && !isLost && <div className="h-[22px]" />}
          </div>

          {/* Action Icons */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => {
                setEmpPopup(true);
                setEmpData(deal);
              }}
              title="Quick View"
              className="p-2 rounded-full bg-slate-100 hover:bg-blue-100 hover:text-blue-600 text-slate-500 transition"
            >
              <Eye className="size-4" />
            </button>

            <button
              onClick={() => !isWonOrLost && setShowEditModal(true)}
              className={`p-2 rounded-lg hover:bg-slate-100 text-slate-600 transition ${
                isWonOrLost ? "opacity-40 cursor-not-allowed" : ""
              }`}
              title="Edit Deal"
              disabled={isWonOrLost} // <- button ko bhi disable kar diya
            >
              <Pencil size={16} />
            </button>

            <button
              onClick={() => !isWonOrLost && handleStageChange("Won")}
              title="Mark as Won"
              className={`p-2 rounded-full transition ${
                isWon
                  ? "bg-green-500 text-white"
                  : "bg-slate-100 text-slate-500 hover:bg-green-100 hover:text-green-600"
              }`}
            >
              <ThumbsUp className="size-4" />
            </button>

            <button
              onClick={() => !isWonOrLost && handleStageChange("Lost")}
              title="Mark as Lost"
              className={`p-2 rounded-full transition ${
                isLost
                  ? "bg-rose-500 text-white"
                  : "bg-slate-100 text-slate-500 hover:bg-rose-100 hover:text-rose-600"
              }`}
            >
              <ThumbsDown className="size-4" />
            </button>
          </div>
        </div>
      </div>

      {showEditModal && (
        // <EditDealModal
        //   open={showEditModal}
        //   onClose={() => setShowEditModal(false)}
        //   dealData={deal}
        //   PackageList={PackageList}
        //   DealStages={DealStages}
        //   ProductList={ProductList}
        //   ClientList={ClientList}
        //   UserList={UserList}
        //   contactId={userid}
        //   onDealUpdated={() => onStatusChange(deal.dealid)}
        //   onSubmit={handleSuccess}
        //   onError={handleError}
        // />

        <EmployeeDirectoryAddUpdate
              open={showEditModal}
              onClose={() => {
                setShowEditModal(false)
              }}
              data={deal}
              tabIndex={1}
              contactId={userid}
              onDealUpdated={() => onStatusChange(deal.dealid)} // refresh after update
              onSubmit={handleSuccess}
              onError={handleError}
            />
      )}

      {/* Won Deal Modal */}
      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onDealUpdated={() => onStatusChange(deal.dealid)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {empPopup && (
        <DealQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          DealStages={DealStages}
        />
      )}
    </>
  );
}

function TabPlaceholder({ icon: Icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-slate-300 rounded-2xl bg-white">
      <div className="flex items-center justify-center size-14 rounded-full bg-slate-100 mb-4">
        <Icon className="size-6 text-slate-500" />
      </div>
      <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      <div className="mt-4 px-4 py-2 text-xs text-slate-400 border border-solid border-slate-200 rounded-full bg-slate-50">
        🚧 Under Development
      </div>
    </div>
  );
}
